"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Shifts_1 = __importDefault(require("./Entity/Shifts"));
var ShiftsApi = /** @class */ (function () {
    function ShiftsApi(session) {
        this.shiftsEntity = new Shifts_1.default(session);
    }
    ShiftsApi.prototype.getShifts = function (teamId) {
        return this.shiftsEntity.getShifts(teamId);
    };
    ShiftsApi.prototype.updateShifts = function (teamId, configuration) {
        return this.shiftsEntity.updateShifts(teamId, configuration);
    };
    ShiftsApi.prototype.getBreaks = function (teamId) {
        return this.shiftsEntity.getBreaks(teamId);
    };
    ShiftsApi.prototype.updateBreaks = function (teamId, configuration) {
        return this.shiftsEntity.updateBreaks(teamId, configuration);
    };
    ShiftsApi.prototype.startShift = function (userId, teamId) {
        return this.shiftsEntity.startShift(userId, teamId);
    };
    return ShiftsApi;
}());
exports.default = ShiftsApi;
//# sourceMappingURL=ShiftsApi.js.map